/**
 * sanitizeStubText - scrub historical copilot stub strings.
 *
 * New messages are sanitized server-side (agent.py), but messages
 * written BEFORE the fix still contain env-var leaks in the database.
 * This runs at display time so users never see developer jargon.
 *
 * Used by: MessageBubble (message bodies) + CopilotDrawer (list previews).
 */
export function sanitizeStubText(text: string): string {
  if (!text) return text;
  return text
    .replace(/\(stub\)\s*/gi, "")
    .replace(/set\s+CLAUDE_LIVE\s*=\s*true[^.]*/gi, "")
    .replace(/ANTHROPIC_API_KEY/gi, "API key")
    .replace(/CLAUDE_LIVE/gi, "AI features")
    .replace(/Once the real Claude is connected[^.]*/gi, "AI features are being configured.");
}
